<template>
  <div>
    <div class="mt-1">
      <p class="text-start ms-4 text-secondary">
        Listado de Categoría por Perfil
      </p>

   
      <div class="col-12 d-flex justify-content-end">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px;">
          <span class="input-group-text buscar-estiloCuadrado">
            <i class="bi bi-search"></i>
          </span>
          <input class="form-control buscar-estiloCuadrado" type="text" placeholder="Buscar categoría o perfil"
            v-model="busqueda" @input="Filtro" />
        </div>
      </div>

     
      <div class="table-responsive mx-2 mt-2 py-3">
        <table class="table table-bordered tamañoLetra">

        
          <thead class="reducirTamaño">
            <tr class="text-nowrap text-white bg-solimano text-center">
              <th>ID</th>
              <th>CATEGORÍA</th>
              <th>PERFIL</th>
              <th>CREACIÓN</th>
              <th>ACTUALIZACIÓN</th>
              <th><i class="bi bi-boxes fs-5"></i></th>
            </tr>
          </thead>

         
          <tbody class="text-nowrap text-center texto-fini align-middle">

        
            <tr v-if="loading">
              <td colspan="6" class="text-center" style="height: 220px;">
                <div class="d-flex flex-column align-items-center justify-content-center h-100">
                  <div class="spinner-border text-warning" style="width: 3rem; height: 3rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-6">
                    Filtrando información...
                  </div>
                </div>
              </td>
            </tr>

           
            <tr v-else v-for="lista in paginatedLista" :key="lista.idCatxPerfil" class="reducirTamaño">
              <td>{{ lista.idCatxPerfil }}</td>
              <td class="text-start">{{ lista.catNombre }}</td>
              <td>{{ lista.perNombre }}</td>
              <td>{{ lista.audfechaCreacion }}</td>
              <td>{{ lista.audfechaActualizacion }}</td>

              <td>
                <button @click="openEditModal(lista)" class="btn btn-warning mx-1 py-0 px-2">
                  <i class="bi bi-pencil text-white fs-5"></i>
                </button>

                <button @click="eliminar(lista.idCatxPerfil)" class="btn btn-light text-danger py-0 px-2">
                  <i class="bi bi-trash3 fs-5"></i>
                </button>
              </td>
            </tr>

          </tbody>
        </table>
      </div>

    
      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <span class="pagination-info small">
          Página {{ currentPage }} de {{ totalPages }}
        </span>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>

        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>

      </div>

    
      <b-modal ref="editModal" centered hide-footer hide-close-button dialog-class="modal-md">
        <template #modal-title>
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-boxes fs-4 text-primary"></i>
            <span class="fw-semibold">Editar Categoría x Perfil</span>
          </div>
        </template>

        <div class="container-fluid">


          <div class="mb-3">
            <label class="form-label fw-semibold">Categoría:</label>
            <select class="form-select" v-model="idCategoria">
              <option disabled value="">Seleccione Categoría</option>
              <option v-for="item in ListaCategorias" :key="item.idCategoria" :value="item.idCategoria">
                {{ item.catNombre }}
              </option>
            </select>
          </div>

          <!-- PERFIL -->
          <div class="mb-3">
            <label class="form-label fw-semibold">Perfil:</label>
            <select class="form-select" v-model="idPerfil">
              <option disabled value="">Seleccione Perfil</option>
              <option v-for="item in ListaPerfil" :key="item.idPerfil" :value="item.idPerfil">
                {{ item.perNombre }}
              </option>
            </select>
          </div>

          <!-- BOTONES -->
          <div class="d-flex justify-content-end mt-4 gap-2">
            <b-button variant="success" class="px-4" @click="saveChanges">
              <i class="bi bi-check-circle"></i>
            </b-button>

            <b-button variant="outline-secondary" class="px-4" @click="closeEditModal">
              <i class="bi bi-x-lg"></i>
            </b-button>
          </div>

        </div>
      </b-modal>

    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert";
import Swal2 from "sweetalert2";
export default {
  name: "PowerbyTablaCatexperfil",

  data() {
    return {
      itemsPerPage: 10, // Cantidad de elementos por página
      currentPage: 1, // Página actual
      idPerfil: "",
      idCategoria: "",
      idCatxPerfil: "",
      nombrePerfil: "",
      nombreCategoria: "",
      busqueda: "",
      loading: false,
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
  },

  computed: {
    ...mapGetters("acciones", [
      "ListaModulos",
      "ListaCategorias",
      "ListaCatxPerfil",
      "ListaPerfil",
    ]),

    filteredList() {
      const f = (this.busqueda || "").toLowerCase().trim();
      if (!f) return this.ListaCatxPerfil;

      return this.ListaCatxPerfil.filter(item =>
        item.catNombre.toLowerCase().includes(f) ||
        item.perNombre.toLowerCase().includes(f)
      );
    },

    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemsPerPage);
    },

    paginatedLista() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredList.slice(start, start + this.itemsPerPage);
    },
  },

  created() {
    this.ListarCategorias();
  },

  methods: {
    ...mapActions("acciones", ["ListarCategorias", "ListarCatxPerfil"]),

    eliminar(id) {
      this.axios
        .delete(`BIClientes/EliminarCatxPerfil?idCatxPerfil=${id}`)
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            this.ListarCatxPerfil();
            Swal2.fire({
              position: "center",
              icon: "success",
              title: "Se realizó cambios",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      console.log(id);
    },
    Cambiar(idperfil) {
      console.log(idperfil);
      this.axios
        .put(`BIClientes/ModificarEstadoCatxPerfil?idcatxperfil=${idperfil}`)
        .then((r) => {
          console.log(r.data);
          Swal(`Se realizo los cambios`, "", "success");
          this.ListarCatxPerfil();
        });
    },

    openEditModal(lista) {
      this.idPerfil = lista.idPerfil;
      this.idCategoria = lista.idCategoria;
      this.idCatxPerfil = lista.idCatxPerfil;
      this.nombreCategoria = lista.catNombre;
      this.nombrePerfil = lista.perNombre;
      console.log(lista);
      this.$refs.editModal.show();
    },

    closeEditModal() {
      this.idPerfil = "";
      this.nombrePerfil = "";
      this.$refs.editModal.hide();
    },

    saveChanges() {
      // Aquí puedes guardar el nombre editado y realizar otras operaciones necesarias
      // Luego, cierra el modal
      const from = {
        idUsuario: this.idUsuario,
        idCategoria: this.idCategoria,
        idPerfil: this.idPerfil,
        idCatxPerfil: this.idCatxPerfil,
      };

      console.log(from);
      this.axios.put(`BIClientes/Modificarcatxper`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          Swal(`Se realizo los cambios`, "", "success");
          this.ListarCatxPerfil();
          this.closeEditModal();
        } else {
          Swal2.fire({
            icon: "error",
            title: `LA CATEGORIA Y EL PERFIL SELECCIONADOS YA SE ENCUENTRAN ASOCIADOS`,
            text: "",
            footer: "",
          });
        }
      });
    },
    Filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 800);

    },
  },
};
</script>

<style scoped>
.b-modal .modal-header button.close {
  display: none;
}

.bg-solimano {
  text-align: center;
  background: #0080c8;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.letra {
  font-weight: 600;
}

/* .icon-selector {
  display: flex;
  gap: 10px;
} */
.bg-iconos {
  background: #f7f7f7;
}

.icon-selector div {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 2px;
}

.icon-selector div.selected {
  border-color: #007bff;
  /* Color de borde al seleccionar */
}

.icon-selector i {
  font-size: 24px;
  /* Tamaño de los iconos */
}

.tamañoLetra {
  font-size: 0.8rem;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>
